import React from 'react';
import Page from '../../layout/Page';
import AppCredit from './AppCredit';
import RequireFeature, { Features } from '../../RequireFeature';

const AppCreditPage = () => (
    <RequireFeature requiredFeatures={Features.AppCredit}>
        <Page title='App Credit' icon='coins'>
            <AppCredit />
        </Page>
    </RequireFeature>
);

export default AppCreditPage;
